import { render, staticRenderFns } from "./IYellow.vue?vue&type=template&id=28f4f8e6&"
import script from "./IYellow.vue?vue&type=script&lang=ts&"
export * from "./IYellow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports